/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Permissions_Searchusersplaceholder3Inputs */

const en_coinvestments_permissions_searchusersplaceholder3 = /** @type {(inputs: Coinvestments_Permissions_Searchusersplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search users by name or email...`)
};

/**
* | output |
* | --- |
* | "Search users by name or email..." |
*
* @param {Coinvestments_Permissions_Searchusersplaceholder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_permissions_searchusersplaceholder3 = /** @type {((inputs?: Coinvestments_Permissions_Searchusersplaceholder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Permissions_Searchusersplaceholder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_permissions_searchusersplaceholder3(inputs)
});
export { coinvestments_permissions_searchusersplaceholder3 as "coInvestments_permissions_searchUsersPlaceholder" }